module.exports = __webpack_public_path__ + "static/media/object-detection.json.b776f784.resp";